/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceDeviceidPost } from '../fn/azure/api-v-3-service-deviceid-post';
import { ApiV3ServiceDeviceidPost$Params } from '../fn/azure/api-v-3-service-deviceid-post';

@Injectable({ providedIn: 'root' })
export class ApiFromAzureService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceDeviceidPost()` */
  static readonly ApiV3ServiceDeviceidPostPath = '/api/v3/service/deviceid';

  /**
   * Setting the mobile device ID to the client.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceDeviceidPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceDeviceidPost$Response(params?: ApiV3ServiceDeviceidPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceDeviceidPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Setting the mobile device ID to the client.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceDeviceidPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceDeviceidPost(params?: ApiV3ServiceDeviceidPost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceDeviceidPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
